import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { SolicitacaoService } from 'app/service/solicitacao/solicitacao.service';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import * as CryptoJS from 'crypto-js';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';

@Component({
  selector: 'app-controle',
  templateUrl: './controle.component.html',
  styleUrls: ['./controle.component.scss']
})
export class ControleComponent implements OnInit {

  result ;
  progressBar= false;
 resultEmRecuperacao;
 loading = false;
 pendenteRecuperacao = [];
 emRecuperacao = [];
 rgInput ;
 horizontalPosition: MatSnackBarHorizontalPosition = 'right';
 verticalPosition: MatSnackBarVerticalPosition = 'top';
 logIsvisivel = false;
 logs = [];
 idCaixas: any[] = [];
 buttonRelatorio;
 @ViewChild(MatPaginator) paginator: MatPaginator;
 @ViewChild(MatSort) sort: MatSort;
 dataSource = new MatTableDataSource<any[]>([]);
 displayedColumns = ['select', 'solicitacao', 'rgCaixa', 'depto', 'numeroCaixa', 'alocacao','cliente'];
 allCaixas = [];
 tipoSolicitacao: string;

  constructor(public dialogRef: MatDialogRef<ControleComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service : SolicitacaoService,
    private solicitacaoService: SolicitacaoService,
    private _snackBar: MatSnackBar) {
      console.log(data);
      this.tipoSolicitacao = data.tipoSolicitacao;
      if (this.tipoSolicitacao.includes('devolucaoRecipiente')) {
        this.tipoSolicitacao = 'DEV';
      } else {
        this.tipoSolicitacao = 'REQ';
      }
     }

  ngOnInit() {
    if (this.tipoSolicitacao.includes('REQ')) {
      this.carregarPendenteRecuperacao();
    } else {
      this.carregarPendenteDevolucao();
    }
  }

  carregarPendenteRecuperacao(){
    this.loading = true;
    this.service.listarCaixasPendeteRecuperacao().subscribe(data=>{
      this.result = data;
      console.log(this.result)
      if(this.result.cod == 200){
        this.pendenteRecuperacao = this.result.result;
        if (this.pendenteRecuperacao.length > 0) {
          this.pendenteRecuperacao.map(element => {
            if (element.idControle === null) {
              this.allCaixas.push(element);
            }
          });
          console.log(this.allCaixas);
          this.dataSource = new MatTableDataSource(this.allCaixas);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          console.log(this.allCaixas);
        }
        this.loading = false;
      }
    })
  }

  carregarPendenteDevolucao(){
    this.loading = true;
    this.service.listarCaixasPendeteDevolucao().subscribe(data=>{
      this.result = data;
      console.log(this.result)
      if(this.result.cod == 200){
        this.pendenteRecuperacao = this.result.result;
        if (this.pendenteRecuperacao.length > 0) {
          this.pendenteRecuperacao.map(element => {
            if (element.idControle === null) {
              this.allCaixas.push(element);
            }
          });
          console.log(this.allCaixas);
          this.dataSource = new MatTableDataSource(this.allCaixas);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          console.log(this.allCaixas);
        }
        this.loading = false;
      }
    })
  }

  criarControle() {
    if (this.idCaixas.length > 0) {
      this.solicitacaoService.criarControle(this.idCaixas).subscribe(data => {
        console.log(data);
        this.openSnackBarSuccess(`Controle ${data.id} criado com sucesso !`);
        this.dialogRef.close();
      }, err => {
        console.error(err);
      });
    } else {
      this.openSnackBarError('Nenhuma caixa selecionada !');
    }
  }

  checkIndividual(checked, idCaixa) {
    console.log(idCaixa);
    if (checked === true) {
      this.idCaixas.push(idCaixa);
    } else {
      let index = this.idCaixas.indexOf(idCaixa);
      this.idCaixas.splice(index, 1);
    }
    if (this.idCaixas.length > 0) {
      this.buttonRelatorio = false;
    } else {
      this.buttonRelatorio = true;
    }
  }

  checkAll(e) {
    var pageIndex = this.paginator.pageIndex;
    var pageSize = this.paginator.pageSize;
    var lengthData = this.paginator.length;
    if (e === true) {
      for (let i = pageIndex * pageSize; i < (pageIndex * pageSize) + pageSize && i < lengthData; i++) {
        this.dataSource.data[i]['isSelected'] = true;
        this.idCaixas.push(this.dataSource.data[i]['id']);
        this.buttonRelatorio = false;
      }
    } else {
      for (let i = pageIndex * pageSize; i < (pageIndex * pageSize) + pageSize && i < lengthData; i++) {
        this.dataSource.data[i]['isSelected'] = false;
        var id = this.dataSource.data[i]['id'];
        let index = this.idCaixas.indexOf(id);
        this.idCaixas.splice(index, 1);
        this.buttonRelatorio = true;
      }
    }
  }

  openSnackBarSuccess(message: string) {
    this._snackBar.open(message, '', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 4000,
      panelClass: ['success-snackbar']
    });
  }

  openSnackBarError(message: string) {
    this._snackBar.open(message,'', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000,
      panelClass: ['error-snackbar']
    });
  }

}



// WEBPACK FOOTER //
// /app/src/app/components/solicitacao/controle/controle.component.ts